<template>
  <v-dialog
    v-model="value"
    @input="$emit('input', value)"
    width="640"
    persistent
  >
    <v-card :style="'height:480px;width:640px;'">
      <v-quagga
        v-if="value == true"
        :onDetected="logIt"
        :readerTypes="typeComp"
      ></v-quagga>
      <v-btn class="ma-2" icon dark @click="$emit('input', false)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>




<script>
export default {
  name: "ean-scan-dialog",
  props: ["value", "type"],
  data() {
    return {
      types: [
        "ean_reader",
        "code_128_reader",
        "code_39_reader",
        "ean_8_reader",
        "code_39_vin_reader",
        "codabar_reader",
        "upc_reader",
        "upc_e_reader",
        "i2of5_reader",
        "2of5_reader",
        "code_93_reader",
      ],
      renderSize: {
        width: this.$bodySize().width,
        height: this.$bodySize().height,
      },
    };
  },
  computed: {
    typeComp() {
      switch (this.type) {
        case null:
          return [this.types[0]];

        case "EAN13":
          return [this.types[0]];

        case "EAN128":
          return [this.types[1]];

        case "CODE39":
          return [this.types[2]];

        default:
          return [this.types[0]];
      }
    },
  },
  methods: {
    logIt(data) {
      this.$emit("scan", data.codeResult.code);
      this.$emit("input", false);
    },
  },
};
</script>
